import CheckboxGroup from './checkbox-group';

/* istanbul ignore next */
CheckboxGroup.install = function(Vue) {
  Vue.component(CheckboxGroup.name, CheckboxGroup);
};

export default CheckboxGroup;
